/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-undef */
import 'dayjs/locale/lt';

import HeaderTags from '../components/common/HeaderTags';
import XTable from '../components/common/XTable';
import { HistoryDialogProvider } from '../contexts/useHistoryDialog';
import { IVAZDialogProvider } from '../contexts/useIVAZDialog';
import { PageProvider } from '../contexts/usePageContext';
import { ReportDialogProvider } from '../contexts/useReportDialog';
import useTablePage from '../hooks/useTablePage';
import { getTableStart } from '../redux/warehouse/warehouseSlice';

const NAME = 'warehouse';

const WarehousePage = () => {
 const { apiRef, items, rowCount, loading, dispatch } = useTablePage(NAME);

 return (
  <PageProvider pageName={NAME}>
   <ReportDialogProvider>
    <HistoryDialogProvider>
     <IVAZDialogProvider>
      <HeaderTags entityKey={NAME} />
      <XTable
       columns={[]}
       apiRef={apiRef}
       table={NAME}
       rows={items}
       rowCount={parseInt(rowCount, 10)}
       fetchData={(data: Record<string, unknown>) =>
        dispatch(getTableStart({ table: NAME, ...data }))
       }
       isServerMode={false}
       loadAllClientSide
       loading={loading.getTable || false}
      />
     </IVAZDialogProvider>
    </HistoryDialogProvider>
   </ReportDialogProvider>
  </PageProvider>
 );
};

export default WarehousePage;
